import { Component } from 'solid-js'
import {
  IconHome,
  IconEnvelope,
  IconUser,
  IconHeart,
  IconTrophy,
  IconSpark,
  IconChat,
  IconCompass,
  IconGrid,
  IconDoc,
  IconGallery,
  IconCoin,
  IconCard,
  // IconBolt, // #215: only used by the hidden "Become a Creator" nav item — re-add with it.
  IconQuestion,
  IconSend,
} from './Icons'
import { DiamondIcon } from './DiamondIcon'

export type NavItem = {
  id: string
  label: string
  icon: Component<{ size?: number }>
  route?: string
  action?: string
  loggedInOnly?: boolean
  children?: NavSubItem[]
}

export type NavSubItem = {
  id: string
  label: string
  route: string
}

export type NavSection = {
  id: string
  label: string
  adminOnly?: boolean
  items: NavItem[]
}

export const navSections: NavSection[] = [
  {
    id: 'discover',
    label: 'Discover',
    items: [
      { id: 'home', label: 'Home', icon: IconHome, route: '/' },
      // { id: 'inbox', label: 'Inbox', icon: IconEnvelope, route: '/inbox', loggedInOnly: true },
      {
        id: 'account',
        label: 'My Account',
        icon: IconUser,
        loggedInOnly: true,
        children: [
          { id: 'subs', label: 'Subscriptions', route: '/subscriptions' },
          { id: 'payments', label: 'Payment History', route: '/payment-history' },
          { id: 'settings', label: 'Settings', route: '/settings' },
        ],
      },
      { id: 'following', label: 'Following', icon: IconHeart, route: '/following' },
      { id: 'top', label: 'Top Creators', icon: IconTrophy, route: '/top-creators' },
    ],
  },
  {
    id: 'create',
    label: 'Create',
    items: [
      { id: 'generate', label: 'Generate Image', icon: IconSpark, route: '/generate-image', loggedInOnly: true },
      { id: 'chat', label: 'Live Chat', icon: IconChat, route: '/live-chat', loggedInOnly: true },
    ],
  },
  {
    id: 'explore',
    label: 'Explore',
    items: [
      { id: 'characters', label: 'Characters', icon: IconCompass, route: '/characters' },
      { id: 'directory', label: 'Directory', icon: IconGrid, route: '/directory' },
      { id: 'requests', label: 'Requests', icon: IconDoc, route: '/requests' },
      { id: 'gallery', label: 'My Gallery', icon: IconGallery, route: '/gallery', loggedInOnly: true },
      { id: 'blog', label: 'Blog', icon: IconDoc, route: '/blog' },
    ],
  },
  {
    id: 'more',
    label: 'More',
    items: [
      { id: 'tokens', label: 'Tokens', icon: IconCoin, action: 'buyTokens' },
      // #215: "Become a Creator" hidden per Andy — re-add later. Page + route kept intact.
      // { id: 'creator', label: 'Become a Creator', icon: IconBolt, route: '/become-creator' },
      { id: 'faq', label: 'FAQ', icon: IconQuestion, route: '/faq' },
      { id: 'contact', label: 'Contact', icon: IconSend, route: '/contact-us' },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    adminOnly: true,
    items: [
      { id: 'admin-users', label: 'All Users', icon: IconUser, route: '/admin/users' },
      { id: 'admin-subs', label: 'All Subscriptions', icon: IconCard, route: '/admin/subs' },
      { id: 'admin-tx', label: 'All Transactions', icon: IconCoin, route: '/admin/transactions' },
    ],
  },
]

export const topBarNavLinks = [
  { id: 'characters', label: 'Characters', route: '/characters' },
  { id: 'directory', label: 'Directory', route: '/directory' },
  { id: 'generate', label: 'Generate Image', route: '/generate-image' },
  { id: 'chat', label: 'Live Chat', route: '/live-chat' },
]

export const bottomTabs = [
  { id: 'home', label: 'Home', icon: IconHome, route: '/' },
  { id: 'browse', label: 'Browse', icon: IconCompass, route: '/characters' },
  { id: 'create', label: 'Create', icon: IconSpark, route: '/generate-image', fab: true },
  { id: 'chat', label: 'Chat', icon: IconChat, route: '/live-chat' },
  { id: 'premium', label: 'Premium', icon: DiamondIcon, route: '/pricing' },
]
